import PropTypes from "prop-types"
import React from "react"
import { useCurrentWidth } from "react-socks"

import { Button } from "../inputs"
import { FeatureContainer, FeatureCTA } from "./styled"
import { H2, YekanParagraph, CTAText } from "../typography"
import { colors, breakpoints } from "../../utils/styleVariables"
import FeatureList from "./list"

const Container = ({ data, images, perRow, premium, ...rest }) => {
  const { title, subtitle, cta, featureList, secondList } = data
  const truncatedFeatureList = useCurrentWidth() < breakpoints["laptop"] && premium ? featureList.slice(0,4) : featureList

  return (
    <FeatureContainer direction="vertical" {...rest}>
      <div className="text">
        <H2 style={{ textAlign: "center" }}>{title}</H2>
        <YekanParagraph>{subtitle}</YekanParagraph>
      </div>
      <FeatureList premium={premium} items={truncatedFeatureList} images={images.nodes} perRow={perRow} />
      {secondList && (
        <FeatureList secondary items={secondList} images={images.nodes} perRow={perRow} />
      )}
      <FeatureCTA>
        {cta && cta.title && <CTAText>{cta.title}</CTAText>}
        {cta && cta.description && <YekanParagraph>{cta.description}</YekanParagraph>}
        {cta && cta.button && (
          <Button
            text={cta.button}
            name={cta.button}
            to={cta.to}
            shadowColor={colors.coralShadow}
            backgroundColor={[...colors.coral, "0.3"]}
            color={colors.coral}
          />
        )}
      </FeatureCTA>
    </FeatureContainer>
  )
}

Container.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    ctaTitle: PropTypes.string,
    ctaButton: PropTypes.string,
    featureList: PropTypes.array,
  }),
  images: PropTypes.shape({
    nodes: PropTypes.array,
  }),
  preRow: PropTypes.number,
  premium: PropTypes.bool
}

Container.defaultProps = {
  perRow: 5
}
export default Container
